import Swiper, { Scrollbar} from 'swiper';
Swiper.use([Scrollbar]);


export namespace ThreeUpSlider {
	let setupSlider = () => {
		let sliderContainers = document.querySelectorAll('.js-three-up-slider');

		if(!sliderContainers.length) {
			return;
		}

		sliderContainers.forEach((slider, index) => {
			let sliderList = [];

			slider.classList.add(`three-up-slider--${index}`);

			//setup each swiper instance
			let swiper:any = new Swiper(`.three-up-slider--${index}`,{
				// Optional parameters
				slidesPerView: 3,
				scrollbar: {
					el: `.three-up-slider--${index} .swiper-scrollbar`,
					draggable: true,
					hide: false
				},
				navigation: false,
				breakpoints: {
					0: {
						slidesPerView: 2,
					},
					768: {
						slidesPerView: 3,
					},
				},
			});

			//push up the swiper data
			sliderList.push(swiper);
			swiper.init();
		});
	}

	export const init = () => {
		setupSlider();
	}
}

/**
 * DOMContentLoaded may fire before script has a chance to run, so it is wise to check before adding
 */
if (document.readyState === 'loading') {  // Loading hasn't finished yet
	document.addEventListener('DOMContentLoaded', ThreeUpSlider.init);
} else {  // `DOMContentLoaded` has already fired
	ThreeUpSlider.init();
}
